import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FileClaimComponent } from './file-claim.component';

const routes: Routes = [
  {
    path: '',
    component: FileClaimComponent,
    children: [
      {
        path: 'additional-question',
        loadChildren: () => import('./additional-question/additional-question.module').then(m => m.AdditionalQuestionModule),
      },
      {
        path: 'claim-question',
        loadChildren: () => import('./claim-questions/claim-questions.module').then(m => m.ClaimQuestionsModule),
      },
      {
        path: 'cover-item-additional-question',
        loadChildren: () => import('./cover-item-additional-question/cover-item-additional-question.module').then(m => m.CoverItemAdditionalQuestionModule),
      },
      {
        path: 'file-claim-listing',
        loadChildren: () => import('./file-claim-listing/file-claim-listing.module').then(m => m.FileClaimListingModule),
      },
      {
        path: 'first-question',
        loadChildren: () => import('./first-questions/first-questions.module').then(m => m.FirstQuestionsModule),
      },
      {
        path: 'all-claim-history',
        loadChildren: () => import('./claim-history-list/claim-history-list.module').then(m => m.ClaimHistoryListModule),
      },
      {
        path: 'purchase-claim',
        loadChildren: () => import('./purchase-claim/purchase-claim.module').then(m => m.PurchaseClaimModule),
      },
      {
        path: 'payout-claim',
        loadChildren: () => import('./payout-claim/payout-claim.module').then(m => m.PayoutClaimModule),
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FileClaimRoutingModule { }
